import { configureStore } from "@reduxjs/toolkit";

const toolkitReducers = {
  // navLinks: navLinksReducer,
  // auth: authReducer,
  // register: registerReducer,
};
const store = configureStore({
  reducer: toolkitReducers,
});
export default store;
